/* src/app/module/service-provider/add-sp-new-component/incharge-owner-details/incharge-owner-details.component.scss */
button.btn.btn-primary {
  padding: 10px 15px;
  border-radius: 5px;
  margin-top: 43px;
  font-size: 16px;
  font-weight: 600;
}
.heading {
  margin-bottom: 23px;
  font-size: 20px;
  font-weight: 600;
}
::ng-deep h3 {
  margin-top: 0px;
  margin-bottom: 10px;
}
form {
  width: 750px;
}
::ng-deep input {
  margin-top: 8px;
  margin-bottom: 4px;
}
/*# sourceMappingURL=incharge-owner-details.component-LNCGELFK.css.map */
